import { ChromeMessage, ChromeMessageType } from '../../types';
import { getChromeRuntime } from '../wrappers';
import { getDeviceAndUserStore, getAccountStore } from '../../storage/stores';

export const registerGetTrackingDataHandler = () => {
  getChromeRuntime().onMessage.addListener(getTrackingDataHandler);
};

export const getTrackingDataHandler = (
  message: ChromeMessage,
  _sender: chrome.runtime.MessageSender,
  sendResponse: (response: {
    accountUid: string;
    deviceUid: string;
    profileId: number;
    profileName: string;
  }) => void
) => {
  if (message.type !== ChromeMessageType.GET_TRACKING_DATA) {
    return false;
  }

  const accountStoreData = getAccountStore().get();
  const deviceAndUserData = getDeviceAndUserStore().get();
  if (!deviceAndUserData || !accountStoreData) {
    throw new Error('Device And User store not properly initialized');
  }

  sendResponse({
    accountUid: accountStoreData.accountUid,
    deviceUid: deviceAndUserData.device,
    profileId: deviceAndUserData.profileId,
    profileName: deviceAndUserData.profileName,
  });

  // We must return true so that the message initiator waits for an asynchronous callback call
  return true;
};
